"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domReady = onReady => {
    window.requestAnimationFrame(function check() {
        document.body ? onReady() : window.requestAnimationFrame(check);
    });
};
exports.default = domReady;
